import React from 'react';
import Auxillary from '../../../hoc/Auxillary/Auxillary';
import Button from '../../UI/Button/Button';

const orderSummary=(props)=>{
    const ingredientSummary=Object.keys(props.ingredients)
                                .map((igKey)=>{
                                    return (<li key={igKey}> 
                                                <span style={{textTransform:"capitalize"}} > {igKey} </span>
                                                 : {props.ingredients[igKey]} 
                                            </li>)
                                })

    return <Auxillary>
            <h3>Your Order</h3>
            <p>The delicious burger you ordered contains :</p>
            <ul>
                {ingredientSummary}
            </ul>
            <h5>Total Price : <strong>{props.totalPrice.toFixed(2)}</strong></h5>
            <p>Continue to Checkout ? </p>
            <Button type="Success" clicked={props.continueOrder}>CONTINUE </Button>
            <Button type="Danger" clicked={props.cancelOrder}> CANCEL </Button>
        </Auxillary>

}


export default orderSummary;